// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__y1SOD","logo":"Header_logo__sNK8Q","catalogWrapper":"Header_catalogWrapper__G2gWi"};